import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { AppInstallPermission, StargatePermissionId } from './stargate.types';
import { toMarketplaceProducts, toStargateProducts } from './stargate.utils';
export default function stargateMarketplaceMethods(self) {
  return {
    async appInstallPermission(product, cloudId) {
      const productAdminPermittedPromise = self.permitted(StargatePermissionId.MANAGE, "ari:cloud:".concat(product, "::site/").concat(cloudId));
      const siteAdminPermittedPromise = self.permitted(StargatePermissionId.MANAGE, "ari:cloud:platform::site/".concat(cloudId));
      const [productAdminPermission, siteAdminPermission] = await Promise.all([productAdminPermittedPromise, siteAdminPermittedPromise]);
      return siteAdminPermission.permitted ? AppInstallPermission.CAN_INSTALL_FREE_AND_PAID : productAdminPermission.permitted ? AppInstallPermission.CAN_INSTALL_FREE_ONLY : AppInstallPermission.CANNOT_INSTALL;
    },
    async availableSites(products) {
      const stargateProducts = toStargateProducts(products);
      const {
        sites
      } = await self.availableSites(stargateProducts);
      const marketplaceSites = sites.map(site => _objectSpread(_objectSpread({}, site), {}, {
        products: toMarketplaceProducts(site.products)
      }));
      return {
        sites: marketplaceSites
      };
    }
  };
}